module.exports = __webpack_public_path__ + "img/5-2.add8b995.webp";